import React from "react";

import TeachingStaffHomePageTopAnimation from "./TeachingStaffHomePageTopAnimation";
import TeachersHomePageComponent from "./TeachersHomePageComponent";

const TeachingStaffHomePage = () => {
  return (
    <div>
      <TeachingStaffHomePageTopAnimation />
      <TeachersHomePageComponent />
    </div>
  );
};

export default TeachingStaffHomePage;
